import { Button } from "reactstrap";
import { FaDirections } from "react-icons/fa";
import { SaveIcon, SaveIcon2 } from "../../assets/designedPickedIcons";
import { CiShare2 } from "react-icons/ci";
import { useLocation, useNavigate } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { useSavedPlacesHooks } from "../../hooks/useSavedPlaces";

const PlaceUserOptions = ({ onShare, onSave, onDirections }) => {
  const navigateTo = useNavigate();
  const placeDetails=useSelector((s)=>s?.placeDetails??{},shallowEqual);
  const {handleSavePlace,allSavedItems}=useSavedPlacesHooks();
  const isAlreadySaved=allSavedItems?.find((i)=>i?._id===placeDetails?._id)

  return (
    <div className="user-place-options flex-wrap mt-3 d-flex align-items-center justify-content-center">
      <Button
        onClick={() => navigateTo("/directions",{state:placeDetails})}
        className="user-option-btn  "
      >
        <FaDirections size={24} />
        Directions
      </Button>
      {isAlreadySaved?<Button className="bg-success text-white rounded-pill px-3 py-2" style={{width:150}}>Saved</Button>:
      <Button onClick={()=>handleSavePlace(placeDetails)} className="user-option-btn">
      <SaveIcon2 /> Save
    </Button>}
      <Button className="user-option-btn">
        <CiShare2 strokeWidth={1} size={24} />
        Share
      </Button>
    </div>
  );
};

export default PlaceUserOptions;
